module.exports = __webpack_public_path__ + "media/outcome_video.4fb9335b.mp4";